/*
 * Copyright (c) 2023-2024. Haodong JU
 */

import { getStripePayments } from 'firestore-stripe-payments-jhd'
import {
  createUserWithEmailAndPassword,
  getAuth,
  sendPasswordResetEmail,
  sendSignInLinkToEmail,
  signInWithEmailAndPassword,
  signInWithEmailLink
} from 'firebase/auth'
import { addDoc, collection, doc, getDoc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore'
import { FireBaseApp } from '@/model/firebase/takewayCompat'
import { Remember } from '@/model/global/GlobalSettings'

export const FireBaseAuth = getAuth(FireBaseApp)

const path = 'login-meta-code'

export async function getNewAadenMetaId (email) {
  const dc = await addDoc(collection(FireBaseStore, path), { email })
  return dc.id
}

export async function loginWithAadenMetaId (id) {
  const info = await getDoc(doc(FireBaseStore, path, id))
  await logInWithoutPassword(info.data().email, info.data().url)
}

export async function confirmLogin (id) {
  await setDoc(doc(FireBaseStore, path, id),
    { url: window.location.href },
    { merge: true }
  )
  window.history.replaceState(null, '', window.location.pathname)
}

export function listenForConfirm (id, onConfirm) {
  return onSnapshot(doc(FireBaseStore, path, id), (doc) => {
    console.log(doc.data())
    onConfirm(doc.data())
  })
}

export async function startSignInWithLink (email) {
  const afterUrl = new URL(window.location.href)
  const id = await getNewAadenMetaId(email)
  afterUrl.searchParams.set('aadenMetaId', id)
  const actionCodeSettings = {
    // URL you want to redirect back to. The domain (www.example.com) for this
    // URL must be in the authorized domains list in the Firebase Console.
    url: afterUrl.href,
    // This must be true.
    handleCodeInApp: true
  }
  await sendSignInLinkToEmail(FireBaseAuth, email, actionCodeSettings)
  Remember.lastLoginEmail = email
  return id
}

export async function logInWithoutPassword (email, link) {
  return await signInWithEmailLink(FireBaseAuth, email, link)
}

export const FireBaseStore = getFirestore(FireBaseApp)

export const StripePayment = getStripePayments(FireBaseApp, {
  customersCollection: 'customers',
  productsCollection: 'products'
})

FireBaseAuth.useDeviceLanguage()

// FireBaseAuth.onAuthStateChanged(user => {
//   if (user?.uid) {
//     login(user.uid, user.displayName)
//   } else {
//     store.commit('loginStateReady')
//   }
// })

export async function loginWithEmailAndPassword (email, password) {
  return await signInWithEmailAndPassword(FireBaseAuth, email, password)
}

export async function createUserWithEmail (email, password) {
  return await createUserWithEmailAndPassword(FireBaseAuth, email, password)
}

export async function resetPasswordEmail (email) {
  return await sendPasswordResetEmail(FireBaseAuth, email)
}
